import React from 'react';
import { Box, Fade } from '@mui/material';

const PageContainer = ({ children, maxWidth = 'lg', ...props }) => {
    return (
        <Fade in={true} timeout={800}>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: maxWidth === false ? '100%' : undefined,
                    mx: 'auto',
                    px: { xs: 2, sm: 3, md: 4 },
                    pt: { xs: 4, sm: 6 }, // Increased top padding for premium spacing
                    pb: { xs: 4, sm: 6 },
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    ...props.sx
                }}
                {...props}
            >
                {children}
            </Box>
        </Fade>
    );
};

export default PageContainer;
